export default function preloadImage(imageSrc: string) {
  const image = new window.Image();
  image.src = imageSrc;
}
